import { render, staticRenderFns } from "./QuestionsPreview.vue?vue&type=template&id=1f2dd59d&scoped=true"
import script from "./QuestionsPreview.vue?vue&type=script&lang=js"
export * from "./QuestionsPreview.vue?vue&type=script&lang=js"
import style0 from "./QuestionsPreview.vue?vue&type=style&index=0&id=1f2dd59d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2dd59d",
  null
  
)

export default component.exports